import { Cell, Icon, Text } from '@vinted/web-ui'
import { InfoCircle24 } from '@vinted/monochrome-icons'

type Props = {
  body?: string
}

const HelpCenterInfoBox = ({ body }: Props) => {
  if (!body) {
    return null
  }

  return (
    <Cell
      styling={Cell.Styling.Wide}
      prefix={<Icon name={InfoCircle24} color={Icon.Color.GreyscaleLevel3} />}
      body={<Text as="span" html text={body} />}
      testId="info-box"
    />
  )
}

export default HelpCenterInfoBox
